import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SLoad,
  SPage,
  SScrollView2,
  SText,
  SInput,
  STheme,
  SView,
  SNotification,
} from "servisofts-component";
import SSocket from "servisofts-socket";

class tablapaquetes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      paquetes: [],
      search: "",

      editingKey: null,
      editingValue: "",
      savingKey: null,
    };
  }

  componentDidMount() {
    this.cargarPaquetes();
  }

  cargarPaquetes() {
    this.setState({ loading: true });

    SSocket.sendPromise({
      component: "paquete",
      type: "getAll",
      estado: "cargando",
      key_usuario: this.props.state.usuarioReducer.usuarioLog.key,
    })
      .then((resp) => {
        // si quieres filtrar por estado, hazlo aquí
        const lista = Object.values(resp.data || {});
        this.setState({ paquetes: lista, loading: false });
      })
      .catch((e) => {
        console.error(e);
        this.setState({ loading: false });
      });
  }

  getListaFiltrada() {
    const { paquetes, search } = this.state;
    const q = (search || "").toLowerCase().trim();
    if (!q) return paquetes;

    return paquetes.filter((p) => {
      const key = (p.key || "").toLowerCase();
      const desc = (p.descripcion || "").toLowerCase();
      const estado = String(p.estado_app ?? p.estado ?? "").toLowerCase();
      const key_erp = (p.key_erp || "").toLowerCase();
      const Precio = String(p.precio || "").toLowerCase();
      return key.includes(q) || desc.includes(q) || estado.includes(q) || key_erp.includes(q)|| Precio.includes(q);
    });
  }

  startEditKeyERP = (item) => {
    const current = (item.key_erp || "").trim();
    this.setState({
      editingKey: item.key,
      editingValue: current === "-" ? "" : current,
    });
  };

  guardarKeyERP = async (item) => {
    const value = (this.state.editingValue || "").trim();

    if (!value) {
      SNotification?.send?.({ title: "Key ERP", body: "Ingresa un valor.", type: "warning" });
      return;
    }

    if (this.state.savingKey === item.key) return;

    this.setState({ savingKey: item.key });

    try {
      await SSocket.sendPromise({
        component: "paquete",
        type: "editar",
        data: {
          key: item.key,
          key_erp: value, // si te vuelve a salir error de array literal, cámbialo por: [value]
        },
      });

      this.setState((prev) => ({
        paquetes: prev.paquetes.map((p) =>
          p.key === item.key ? { ...p, key_erp: value } : p
        ),
        editingKey: null,
        editingValue: "",
        savingKey: null,
      }));

      SNotification?.send?.({ title: "Paquete", body: "Key ERP guardado ✅", type: "success" });
    } catch (e) {
      console.error(e);
      this.setState({ savingKey: null });
      SNotification?.send?.({ title: "Error", body: "No se pudo guardar Key ERP.", type: "danger" });
    }
  };

  renderHeader() {
    const th = {
      padding: 10,
      borderBottomWidth: 1,
      borderBottomColor: STheme.color.card,
    };

    return (
      <SView row style={{ backgroundColor: STheme.color.background }}>
        <SText style={{ ...th, width: 150, fontWeight: "700" }}>Key</SText>
        <SText style={{ ...th, flex: 1, fontWeight: "700" }}>Descripción</SText>
        <SText style={{ ...th, width: 120, fontWeight: "700" }}>Estado</SText>
        <SText style={{ ...th, width: 300, fontWeight: "700" }}>Precio</SText>
        <SText style={{ ...th, width: 320, fontWeight: "700" }}>Key ERP</SText>
      </SView>
    );
  }

  renderRow(item) {
    const { editingKey, editingValue, savingKey } = this.state;

    const td = {
      padding: 10,
      borderBottomWidth: 1,
      borderBottomColor: STheme.color.card,
    };

    const isEditing = editingKey === item.key;
    const isSaving = savingKey === item.key;

    // soporta estado_app / estado (según cómo venga)
    const estadoVal = item.estado_app ?? item.estado;
    const estadoTxt = (estadoVal === 1 || estadoVal === true) ? "Activo" : "Inactivo";

    return (
      <SView key={item.key} row style={{ alignItems: "center" }}>
        <SText style={{ ...td, width: 150 }} numberOfLines={1}>
          {item.key}
        </SText>

        <SText style={{ ...td, flex: 1 }} numberOfLines={2}>
          {item.descripcion || item.nombre || "-"}
        </SText>

        <SText style={{ ...td, width: 120 }} numberOfLines={1}>
          {estadoTxt}
        </SText>
        <SText style={{ ...td, width: 300 }} numberOfLines={1}>
          {item.precio != null ? `Bs${item.precio}` : "-"}
        </SText>

        <SView style={{ ...td, width: 300 }}>
          {isEditing ? (
            <SInput
              placeholder="Key ERP"
              value={editingValue}
              onChangeText={(txt) => this.setState({ editingValue: txt })}
              onSubmitEditing={() => this.guardarKeyERP(item)}
              onBlur={() => this.guardarKeyERP(item)}
              editable={!isSaving}
            />
          ) : (
            <SText
              numberOfLines={1}
              style={{ color: STheme.color.secondary }}
              onPress={() => this.startEditKeyERP(item)}
            >
              {isSaving ? "Guardando..." : (item.key_erp || "-")}
            </SText>
          )}
        </SView>
      </SView>
    );
  }

  render() {
    const { loading } = this.state;
    const lista = this.getListaFiltrada();

    return (
      <SPage title="Paquetes">
        {loading ? (
          <SLoad />
        ) : (
          <SScrollView2 style={{ padding: 12 }}>
            <SView style={{ borderRadius: 8, overflow: "hidden" }}>
              {this.renderHeader()}
              {lista.map((it) => this.renderRow(it))}
              {lista.length === 0 ? (
                <SView style={{ padding: 12 }}>
                  <SText>No hay paquetes para mostrar.</SText>
                </SView>
              ) : null}
            </SView>
          </SScrollView2>
        )}
      </SPage>
    );
  }
}

export default connect((state) => ({ state }))(tablapaquetes);
